module.exports = __webpack_public_path__ + "static/media/AS.29565122.png";